import comp from "./CompactLEPreview";
export default comp;
